import React from 'react'
import clsx from 'clsx'
import { CloseCircle } from 'iconsax-react'
import { CircularProgress, useTheme } from '@mui/material'

import Tooltip from '@SonarCX/components/atoms/Tooltip'

import { FILE_EXTENSION } from '..'
import useStyles from './styles'

const NAME_LENGTH_LIMIT = 15

export type NoteProps = {
  media: Media
  loading: boolean
  viewingID: string
  startEdit: (id: string) => void
  deleteNote: (id: string) => void
}

const Note: React.FC<NoteProps> = ({
  media,
  loading,
  viewingID,
  startEdit,
  deleteNote
}) => {
  const theme = useTheme()

  const classes = useStyles()

  const { text, isLong, displayText } = React.useMemo(() => {
    const text = media.filename.replace(FILE_EXTENSION, '')
    const isLong = text.length > NAME_LENGTH_LIMIT
    const displayText = isLong ? text.slice(0, NAME_LENGTH_LIMIT) + '...' : text

    return { text, isLong, displayText }
  }, [media.filename])

  return (
    <div
      onClick={() => !loading && startEdit(media.id)}
      className={clsx(classes.root, loading && classes.loading)}
    >
      {loading && viewingID === media.id && (
        <CircularProgress
          size={theme.size.xs}
          className={classes.loadingIcon}
        />
      )}

      <Tooltip title={isLong ? text : null} arrow>
        <div className={classes.title}>{displayText}</div>
      </Tooltip>

      <CloseCircle
        onClick={e => {
          e.stopPropagation()
          deleteNote(media.id)
        }}
        color={theme.palette.primary.main}
        size={theme.size.base}
        variant='Linear'
        className={classes.deleteIcon}
      />
    </div>
  )
}

export default Note
